import { render } from "./FishMarket.vue?vue&type=template&id=00f63cc2&scoped=true"
import script from "./FishMarket.vue?vue&type=script&lang=js"
export * from "./FishMarket.vue?vue&type=script&lang=js"

import "./FishMarket.vue?vue&type=style&index=0&id=00f63cc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f63cc2"]])

export default __exports__